import { Observable } from 'rxjs';
import { CultureService } from '../services/culture.service';

export const cultureInitializer =
	(cultureService: CultureService, enableLanguageParam = false) =>
	(): Observable<boolean> => {
		let [_, cultureCode] = window.location.pathname.split('/').filter(path => !!path);

		// If the language parameter is enabled and set, that culture is loaded.
		if (enableLanguageParam) {
			const url: URL = new URL(window.location.href);
			const language = url.searchParams.get('language');
			cultureCode = language ? language : cultureCode;
		}

		return cultureService.initialize$(cultureCode);
	};
